import { useEffect } from 'react';

// Блокировка прокрутки страницы под модалкой.
//
// Считаем блокировки, а не переключаем стиль напрямую: модалки бывают вложенными
// (журнал трафбэка → детали клика), и раньше закрытие внутренней возвращало прокрутку
// странице, пока внешняя ещё открыта — вместе со скачком вёрстки на ширину скроллбара.
// Эффект внутренней перезапускается, эффект внешней — нет, потому что её isOpen не
// менялся, так что «выключил последний» — единственная безопасная семантика.
let locks = 0;

const lock = () => {
  locks += 1;
  if (locks > 1) return;

  const scrollbar = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = `${scrollbar}px`;
};

const unlock = () => {
  locks = Math.max(0, locks - 1);
  if (locks > 0) return;

  document.body.style.overflow = 'auto';
  document.body.style.paddingRight = '0px';
};

export const useDisableScroll = (shouldDisable: boolean) => {
  useEffect(() => {
    if (!shouldDisable) return;

    lock();

    return unlock;
  }, [shouldDisable]);
};

export default useDisableScroll;
